export default __webpack_public_path__ + "static/media/malaproject.ab2bc560.jpeg";